// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { QuotaCollectionOperationsService } from '../generated/api/quotaCollectionOperations.service';

@Injectable({ providedIn: 'root' })
export class QuotaCollectionOperationsClientService {
  constructor(private readonly client: QuotaCollectionOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionRecoveryResponse> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsGet(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  getPaymentRecovery(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionPaymentRecoveryResponse> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsGetPaymentRecovery(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  getRetries(
    id: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionRefundRetryPage> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsGetRetries(
      id,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  list(
    consumerAppId?: string,
    state?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13,
    attentionOnly?: boolean,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionPage> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsList(
      consumerAppId,
      state,
      attentionOnly,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  recoverPayment(
    id: string,
    request: WrapperApi.QuotaCollectionPaymentRecoveryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionPaymentRecoveryResponse> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsRecoverPayment(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  retryRefund(
    id: string,
    request: WrapperApi.QuotaCollectionRefundRetryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaCollectionRefundRetryResponse> {
    if (!this.client)
      throw new Error('QuotaCollectionOperationsService is not available');
    return this.client.quotaCollectionOperationsRetryRefund(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
